document.addEventListener("DOMContentLoaded", function () {
  let checkInterval;
  let retries = 0;
  const maxRetries = 20;
  let totalPages = 0;

  function createPaginationLinks(totalPages) {
    const head = document.querySelector("head");

    function getCurrentPage() {
      const urlParams = new URLSearchParams(window.location.search);
      return parseInt(urlParams.get("page")) || 1;
    }

    function updatePaginationLinks() {
      const currentPage = getCurrentPage();

      // Remove old pagination links
      const existingLinks = document.querySelectorAll('link[rel="prev"], link[rel="next"]');
      existingLinks.forEach((link) => link.remove());

      // Add prev link
      if (currentPage > 1) {
        const prevLink = document.createElement("link");
        prevLink.rel = "prev";
        prevLink.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}?page=${currentPage - 1
          }`;
        head.appendChild(prevLink);
      }

      // Add next link
      if (currentPage < totalPages) {
        const nextLink = document.createElement("link");
        nextLink.rel = "next";
        nextLink.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}?page=${currentPage + 1
          }`;
        head.appendChild(nextLink);
      }
    }

    // First time setup
    updatePaginationLinks();

    // Reapply on history state change
    window.addEventListener("popstate", updatePaginationLinks);

    const originalPushState = history.pushState;
    history.pushState = function (state, title, url) {
      originalPushState.call(history, state, title, url);
      updatePaginationLinks();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function (state, title, url) {
      originalReplaceState.call(history, state, title, url);
      updatePaginationLinks();
    };
  }

  checkInterval = setInterval(function () {
    retries++;

    if (retries > maxRetries) {
      clearInterval(checkInterval);
      return;
    }

    const showingItemsElement = document.querySelector(".ns-viewed");
    if (!showingItemsElement) return;

    const text = showingItemsElement.textContent.trim();
    const match = text.match(/of\s+(\d+)\s+products/i);
    if (!match) {
      clearInterval(checkInterval);
      return;
    }

    const totalResults = parseInt(match[1]);
    if (!totalResults || isNaN(totalResults)) {
      clearInterval(checkInterval);
      return;
    }

    const products = document.querySelectorAll("#ns-product-grid .ns-product");
    const pageSize = products.length;
    if (pageSize === 0) return;

    if (totalPages === 0) {
      totalPages = Math.ceil(totalResults / pageSize);
    }

    if (totalPages > 0) {
      createPaginationLinks(totalPages);
      clearInterval(checkInterval);
    }
  }, 500);
});
